<div *ngIf="ready && fileList.length>0">
  <p class="sticky text-primary-500">{{filterList.length}} file</p>
  <input class="e-input" [(ngModel)]="filterValue" (ngModelChange)="checkFilter($event)" placeholder="Cerca un file">

  <div class="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-3 gap-1 w-full resize-y overflow-auto mt-2" *ngIf="filterList.length>0"
    [style]="'min-height: 5rem; height: auto; max-height: 35rem;'">



    @for (a of filterList; track a) {
    <div style="border-radius: 1rem;" class="card m-0 p-0 flex flex-row justify-between w-full h-min shadow-none">

      <div class="flex flex-col p-2 w-2/3">
        <p class="font-medium text-lg">{{a.fileName}}</p>
        <p class="text-sm font-light">{{a.size/1024 ||1 | fileSizeConverter}} - Creato da {{a.uploadedBy}}</p>
        <p class="text-xs font-light">{{a.uploadDate | date: "dd/MM/YYYY hh:mm"}}</p>

      </div>

      <div class="flex justify-start items-center w-1/3">
        <button class="flex justify-center items-center   delete-button p-2 w-full h-full px-5" (click)="deleteInit(a.id)"
          title="Elimina file">

          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-8 h-8">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>

        </button>
        <button class="flex justify-center items-center  edit-button rounded-r-2xl w-full p-2 px-5 h-full" title="Download" (click)="download(a.id,a.fileName,a.filePath)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="w-8 h-8">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
            <path d="M7 11l5 5l5 -5" />
            <path d="M12 4l0 12" />
          </svg>
        </button>
      </div>

    </div>

    }


    <div *ngIf=" filterList.length == 0" class="flex flex-col justify-center align-middle content-center w-full p-1">
      <div class="card m-0 p-2 flex flex-row justify-between w-full h-min">
        <p>Nessun file disponibile</p>

      </div>
    </div>
  </div>
</div>

<div *ngIf="ready && fileList.length==0 " class="flex flex-col justify-center align-middle content-center w-full p-1">
  <div class="card m-0 p-2 flex flex-row justify-between w-full h-min">
    <p>Nessun file disponibile</p>

  </div>
</div>